/**
 * Klaviyo Plugin
 * Ensures _learnq is initialized for event queuing
 * Klaviyo script is loaded via GTM (Google Tag Manager)
 * 
 * This plugin only initializes the _learnq array if needed.
 * The actual Klaviyo script is loaded by GTM.
 */

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') {
    return
  }

  // Don't initialize on /app routes
  const route = useRoute()
  if (route.path.startsWith('/app') || route.path.startsWith('/fr/app')) {
    return
  }

  // Initialize _learnq array if it doesn't exist (for queueing events before script loads)
  // This allows events to be queued even if GTM hasn't loaded Klaviyo yet
  if (!(window as any)._learnq) {
    (window as any)._learnq = []
  }
})
